import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "rs-grid-action-item",
  templateUrl: "./grid-action-item.component.html",
})
export class GridActionItemComponent {
  @Input("image") image: string;
  @Input("text") text: string;
  @Input("disabled") disabled: boolean;
  @Input("children") children: any[] = [];
  @Input("hideArrow") hideArrow: boolean = false;
  @Input() disabledOptions: { [key: string]: any } = {};
  @HostBinding("class.disabled") get hostDisabled() {
    return !!this.disabled;
  }

  ImageType = [
    "Detail",
    "Edit",
    "Duplicate",
    "Refresh",
    "Download",
    "Delete",
    "Note",
    "Send",
    "Copy",
    "Settle",
    "Preview",
    "Export",
    "Move",
    "Add",
    "Update",
    "Import",
    "Upload",
    "AddFolder",
    "Collapse",
    "Combine",
    "Lock",
    "Expand",
    "MoveTo",
    "Publish",
    "ReCalculate",
    "Sync",
    "Share",
    "Rename",
    "SaveSequence",
    "SubmitForApproval",
    "SendToControlPanel",
    "SetReminders",
    "Settle",
    "Template",
    "Workflow",
    "FetchData",
    "ViewStatus",
    "Verify",
  ];
}
